import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export default function CompareTray() {
  const { compare, toggleCompare, clearCompare } = useCart();
  const navigate = useNavigate();
  if (compare.length === 0) return null;

  return (
    <div data-testid="compare-tray" className="fixed bottom-0 left-0 right-0 z-40 bg-[#0B0F12] text-[#FAFAF8] border-t border-[#2A3138]">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3 overflow-x-auto">
        <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#8A8F95] whitespace-nowrap">Compare ({compare.length}/4)</span>
        {compare.map((p) => (
          <div key={p.id} className="flex items-center gap-2 bg-[#151A1F] px-3 py-1.5 whitespace-nowrap">
            <span className="font-display font-bold uppercase text-sm">{p.name} {p.strength}</span>
            <button data-testid={`compare-remove-${p.id}`} onClick={() => toggleCompare(p)} className="text-[#8A8F95] hover:text-white"><X className="w-3.5 h-3.5" /></button>
          </div>
        ))}
        <div className="ml-auto flex gap-2">
          <button onClick={clearCompare} data-testid="compare-clear" className="font-mono2 text-[10px] uppercase tracking-widest text-[#8A8F95] hover:text-white px-3">Clear</button>
          <button data-testid="compare-open" onClick={() => navigate('/compare')} disabled={compare.length < 2}
            className="bg-[#FAFAF8] text-[#0B0F12] px-4 py-2 font-mono2 text-[10px] uppercase tracking-widest disabled:opacity-40 hover:bg-white transition-colors">
            Compare now
          </button>
        </div>
      </div>
    </div>
  );
}
